import Image from "next/image";
import Link from "next/link";
import React from "react";
import { formatImageUrl } from "../../../helper/helper";

const OnlineStores = (props: any) => {
  const { onlineStores } = props;
  return (
    <section className="online_store_section">
      <div className="stores_cards_box">
        {onlineStores?.map((item: any, index: number) => {
          let onlineStoreImage: any = item?.media?.data?.attributes?.url
            ? item?.media?.data?.attributes?.url
            : "";

          return (
            <div className="store_card" key={index}>
              <Link href={item?.cta_link || "/"} target="_blank">
                <Image
                  src={onlineStoreImage || item?.logoURL}
                  alt="logo"
                  width={171}
                  height={29}
                  className="store_logo_img"
                />
                <h1>{item?.title}</h1>
                <Image
                  src="/images/store-arrow.png"
                  alt="arrow"
                  width={24}
                  height={24}
                  className="arrow_icon"
                />
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default OnlineStores;
